import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import SearchBar from 'material-ui-search-bar';
import WarningIcon from '@material-ui/icons/Warning';
import {isNullOrUndefined} from 'util';
import StoriesList from './StoriesList';
import StoryEditor from '../../containers/StoryEditor';
// Actions
import { deleteStory } from '../../actions/Data/Content';

import {getLoadingStatusSelector, getStoriesFlatMap} from '../../selectors/Data';
//import DatasetList from '../components/DatasetList';
//import Uploader from '../components/Uploader';

import * as FS from 'file-saver';

const styles = theme => ({
    root: {
        position: 'absolute',
        backgroundColor: theme.palette.secondary.main,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
    },
    dataList: {
        maxHeight: '10rem',
        overflow: 'auto'
    },
    deets: {
        fontSize: '.75rem',
    },
    error: {
        color: '#F44336',
        display: 'flex',
        fontSize: '.75em',
        alignItems: 'center',
        '& div': {
            paddingLeft: '.75em',
        }
    },
    uploadSuccess: {
        animation: 'fadeIn 2s forwards',
        textAlign: 'center',
        color: '#4CAF50',
        fontWeight: 500,
        fontSize: '.8em',
    },
    '@keyframes fadeIn': {
        'from': { opacity: 0 },
        'to': { opacity: 1 },
    }
});

class Stories extends React.Component {
    constructor(props) {
        super(props);
        //const { classes } = props;
        this.classes = withStyles();
        this.state = { filteredList: [], 
            datasetTitle: "", 
            dialogOpen: false, 
            deletingID: null,
            editStory: null
        };
    }

    componentWillMount() {
        //console.log(this.state.filteredList);
    }

    /*
    componentDidMount() {
        
        /*if (this.props.datasets == null && !this.props.fetching) {
            this.props.dispatch(CmsActions.requestDatasets(this.props.userId));
        } else *//*if (this.state.filteredList != this.props.stories) {
            this.setState({ filteredList: this.props.stories });
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ filteredList: nextProps.stories });
    }*/
    handleSelect(id) {
        var story = this.props.stories.find(x => x.uuid === id);
        /*let metaObj = dataset.Meta;
        console.log(metaObj);*/
        console.log(story);
        this.setState({editStory: story});
    }
    handleDelete(id) {
        var story = this.props.stories.find(x => x.uuid === id);
        /*let metaObj = dataset.Meta;
        console.log(metaObj);*/
        console.log(story,this);
        this.props.deleteStory(id);
        //this.setState({editStory: story});
    }
    handleExit(){
        this.setState({editStory: null});
    }
    handleNewStory() {
        this.setState({editStory: {
            title: 'New Story',
            slug: 'new-story',
            panels: []
        }});
    }
    render() {
        return (
            <>
                <Grid container spacing={24} justify="center">
                    <Grid item xs={5}>
                        <h2>My Stories</h2>
                    </Grid>
                    <Grid item xs={7}>
                        {/*<SearchBar
                            onChange={this.filterDatasetList.bind(this)}
                            onRequestSearch={() => console.log('onRequestSearch')}
                            style={{
                                margin: '0 auto',
                                maxWidth: '100%',
                                fontSize: '0.875rem',
                                margin: 'auto 0.875rem',
                                height: '2rem',
                                iconButtonSearch: {
                                    style: {
                                        height: '2.25rem'
                                    }
                                },
                                iconButtonClose: {
                                    style: {
                                        height: '2.25rem'
                                    }
                                }
                            }}
                        />*/}
                    </Grid>
                    <Grid item xs={12} className={this.classes.dataList}>
                        <StoriesList 
                            stories={this.props.stories} 
                            handleSelect={this.handleSelect.bind(this)}
                            handleDelete={this.handleDelete.bind(this)}
                        />
                        <Button onClick={this.handleNewStory.bind(this)}>Add Story</Button>
                    </Grid>
                </Grid>
                {this.state.editStory&&
                <StoryEditor 
                    isOpen={!isNullOrUndefined(this.state.editStory)} 
                    story={this.state.editStory} 
                    onSave={this.handleExit.bind(this)} 
                    onCancel={this.handleExit.bind(this)} 
                />}
            </>
        );
    }
}
/* ========================================== */
// Redux
/* ========================================== */
const mapStateToProps = store => {
    const getLoading = getLoadingStatusSelector(['stories']);
    return {
        isLoading: getLoading(store),
        stories: getStoriesFlatMap(store)
    };
};
const mapDispatchToProps = dispatch => {
    return bindActionCreators(Object.assign({deleteStory, dispatch}), dispatch);
};
/* ========================================== */
// Export
/* ========================================== */
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Stories));